import { render, staticRenderFns } from "./StoredWorkflowInvocations.vue?vue&type=template&id=253c74f5"
import script from "./StoredWorkflowInvocations.vue?vue&type=script&setup=true&lang=ts"
export * from "./StoredWorkflowInvocations.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports